"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KEPLR_EXT_ANALYTICS_API_AUTH_TOKEN = exports.KEPLR_EXT_ANALYTICS_API_URL = exports.ROUTE = void 0;
exports.ROUTE = "analytics";
exports.KEPLR_EXT_ANALYTICS_API_URL = process.env["KEPLR_EXT_ANALYTICS_API_URL"];
exports.KEPLR_EXT_ANALYTICS_API_AUTH_TOKEN = process.env["KEPLR_EXT_ANALYTICS_API_AUTH_TOKEN"];
//# sourceMappingURL=constants.js.map